﻿import ConfiguratorBuilding from '../classes/datalayer-configurator-building.js';
import ConfiguratorEvent from '../events/configurator-event.js';
import DatalayerConfiguratorBuildingItem from '../classes/datalayer-configurator-building-item.js';

const configuratorName = 'trellus';

export default {
    init: async () => {
        window.expivi._events.onChange.subscribe(async (event) => {
            if (event.name === 'attribute') {
                await trackItemChange(event.payload);
            }

            if (event.name === 'fully_loaded') {
                document.querySelectorAll('button.v-expansion-panel-header').forEach((element) => {
                    element.addEventListener('click', trackStepChange);
                });
            }
        });

        document.addEventListener('trellus-config-pdf-downloaded', await trackDownload);
    }
};

async function trackStepChange(event) {
    let stepValue = '';

    if (event.target === 'p.step-header-name') {
        stepValue = event.target.innerText;
    } else {
        stepValue = event.target.parentElement.querySelector('.step-header-name').innerText;
    }

    const building = new ConfiguratorBuilding();
    building.action = 'change_step';
    building.step = stepValue;
    building.footprint = getFootprintValue();
    building.totalValue = await getPriceValue();

    const dataLayerEvent = new ConfiguratorEvent(configuratorName, building);
    dataLayerEvent.push();
}

async function trackItemChange(eventPayload) {
    const stepValue = getStepValue();

    if (stepValue === '') {
        return;
    }

    const building = new ConfiguratorBuilding();
    building.action = 'add_option';
    building.step = stepValue;
    building.item = new DatalayerConfiguratorBuildingItem(eventPayload.attribute_name, eventPayload.attribute_value_name, null);
    building.footprint = getFootprintValue();
    building.totalValue = await getPriceValue();

    const dataLayerEvent = new ConfiguratorEvent(configuratorName, building);
    dataLayerEvent.push();
}

async function trackDownload() {
    const building = new ConfiguratorBuilding();
    building.action = 'pdf_download';
    building.step = 'complete';
    building.items = await getConfigurationPanels();
    building.footprint = getFootprintValue();
    building.totalValue = await getPriceValue();

    const dataLayerEvent = new ConfiguratorEvent(configuratorName, building);
    dataLayerEvent.push();
}

function getStepValue() {
    const element = document.querySelector('button.v-expansion-panel-header--active');

    if (element === null) {
        return '';
    }

    return element.innerText;
}

function getFootprintValue() {
    const lengthElement = document.querySelector('[data-xpv-attribute-id="251731"] .v-list-item__title');
    const widthElement = document.querySelector('[data-xpv-attribute-id="251730"] .v-list-item__title');

    if (lengthElement === null || widthElement === null) {
        return '';
    }

    return `${lengthElement.innerText.trim()}x${widthElement.innerText.trim()}`;
}

async function getPriceValue() {
    return window.expivi.getPrice()
        .then(price => price);
}

async function getConfigurationPanels() {
    const itemsArray = [];

    return getConfigurationAttributes()
        .then(async (data) => {
            for (const attribute of data) {
                itemsArray.push(new DatalayerConfiguratorBuildingItem(attribute.attribute_name, attribute.attribute_value_name, null));
            }
        })
        .then(() => itemsArray);
}

async function getConfigurationAttributes() {
    return window.expivi.saveConfiguration(0, 0, undefined, undefined, { include_keys: true })
        .then(data => data.configured_products[0].configuration.attributes);
}